
import React, { useState } from 'react';
import { arrayOf, bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import { Field } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { intlShape, injectIntl, FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import { maxLength, required, composeValidators } from '../../util/validators';
import { Form, Button, FieldTextInput, FieldCheckboxGroup, FieldSelect } from '../../components';
import CustomServiceSelectFieldMaybe from './CustomServiceSelectFieldMaybe';
import { findOptionsForSelectFilter } from '../../util/search';
import CustomMockSelectFieldMaybe from './CustomMockSelectFieldMaybe';
import { LISTING_STATE_DRAFT, LINE_ITEM_NIGHT, LINE_ITEM_DAY } from '../../util/types';
import { ensureListing } from '../../util/data';
import config from '../../config';
import * as validators from '../../util/validators';
import { types as sdkTypes } from '../../util/sdkLoader';
import css from './EditListingServiceInfoForm.module.css';
import { formatMoney } from '../../util/currency';


const EditListingServiceInfoFormComponent = props => {

  const initialValues = props.initialValues;
console.log(initialValues)
  const [serviceOption, setServiceOption] = useState("consultation");
  const [showWarning, setShowWarning] = useState(false);
  const [checkedUnsavedService, setCheckedUnsavedService] = useState(false);
  const [brainstormCheckboxesFilled, setBrainstormCheckboxesFilled] = useState("");

  const brainstormOptions = initialValues.brainstorm ? initialValues.brainstorm : [];
  
  const [brainstormOption1, setBrainstormOption1] = useState( brainstormOptions.includes("formulate") ? true : false);
  const [brainstormOption2, setBrainstormOption2] = useState( brainstormOptions.includes("go") ? true : false);
  const [brainstormOption3, setBrainstormOption3] = useState( brainstormOptions.includes("discuss") ? true : false);
  const [brainstormOption4, setBrainstormOption4] = useState( brainstormOptions.includes("discuss1") ? true : false);
  const [brainstormOption5, setBrainstormOption5] = useState( brainstormOptions.includes("share") ? true : false);
  const [brainstormOption6, setBrainstormOption6] = useState( brainstormOptions.includes("other") ? true : false);
  const [personalOption, setPersonalOption] = useState( initialValues.personalStatementEditing ? true : false);
  const [secondaryOption, setSecondaryOption] = useState( initialValues.secondaryStatementEditing ? true : false);
  const [mockOption, setMockOption] = useState( initialValues.mock ? true : false);
 

  
  const handleServiceChange = (service) => {
    

      setServiceOption(service)

   
  }




  return(
  <FinalForm
     mutators={{ ...arrayMutators }}
    {...props}
    render={formRenderProps => {
      const {
        letterOfIntentOptions,
        secondaryStatementEditingOptions,
        personalStatementEditingOptions,
        brainstormOptions,
        mockOptions,
        serviceOptions,
        className,
        disabled,
        ready,
        handleSubmit,
        intl,
        invalid,
        name,
        pristine,
        saveActionMsg,
        updated,
        updateInProgress,
        fetchErrors,
        listing,
        filterConfig
      } = formRenderProps;
      
      const { Money } = sdkTypes;
      const unitType = config.bookingUnitType;
      const isNightly = unitType === LINE_ITEM_NIGHT;
      const isDaily = unitType === LINE_ITEM_DAY;

      const translationKey = isNightly
        ? 'EditListingPricingForm.pricePerNight'
        : isDaily
        ? 'EditListingPricingForm.pricePerDay'
        : 'EditListingPricingForm.pricePerUnit';

      const rulesLabelMessage = intl.formatMessage({
        id: 'EditListingConsultForm.rulesLabel',
      });
      const rulesPlaceholderMessage = intl.formatMessage({
        id: 'EditListingConsultForm.rulesPlaceholder',
      });

      const pricePerUnitMessage = intl.formatMessage({
        id: translationKey,
      });

      const pricePlaceholderMessage = intl.formatMessage({
        id: 'EditListingPricingForm.priceInputPlaceholder',
      });

      const priceRequired = validators.required(
        intl.formatMessage({
          id: 'EditListingPricingForm.priceRequired',
        })
      );
      const minPrice = new Money(config.listingMinimumPriceSubUnits, config.currency);
      const minPriceRequired = validators.moneySubUnitAmountAtLeast(
        intl.formatMessage(
          {
            id: 'EditListingPricingForm.priceTooLow',
          },
          {
            minPrice: formatMoney(intl, minPrice),
          }
        ),
        config.listingMinimumPriceSubUnits
      );
      const priceValidators = config.listingMinimumPriceSubUnits
        ? validators.composeValidators(priceRequired, minPriceRequired)
        : priceRequired;

      const { updateListingError, createListingDraftError, showListingsError } = fetchErrors || {};
      const errorMessageUpdateListing = updateListingError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingDescriptionForm.updateFailed" />
        </p>
      ) : null;

      // This error happens only on first tab (of EditListingWizard)
      const errorMessageCreateListingDraft = createListingDraftError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingDescriptionForm.createListingDraftError" />
        </p>
      ) : null;

      const errorMessageShowListing = showListingsError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingDescriptionForm.showListingFailed" />
        </p>
      ) : null;
      const currentListing = ensureListing(listing);
      const isPublished = currentListing.id && currentListing.attributes.state !== LISTING_STATE_DRAFT;

      const panelTitle = isPublished ? (
        <FormattedMessage
          id="EditListingEditingPanel.title"
          values={{
            listingTitle: (
              <ListingLink listing={listing}>
                <FormattedMessage id="EditListingEditingPanel.listingTitle" />
              </ListingLink>
            ),
          }}
        />
      ) : (
        <FormattedMessage id="EditListingEditingPanel.createListingTitle" />
      );

      const classes = classNames(css.root, className);
      const submitReady = (updated && pristine) || ready;
      const submitInProgress = updateInProgress;
      const submitDisabled = invalid || disabled || submitInProgress;
     // const brainstormOptions = findOptionsForSelectFilter('brainstorm', filterConfig);    !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
     //const options = findOptionsForSelectFilter('editing', filterConfig);

    //  setConsultationPrice={setConsultationPrice}
    //  setBrainstormPrice={setBrainstormPrice}
    //  setmockPrice={setMockPrice}
    //  setPersonalStatementEditingPrice={setPersonalStatementEditingPrice}
    //  setSecondaryStatementEditingPrice={setSecondaryStatementEditingPrice}



      const consultationPrice = props.consultationPrice;
      const setConsultationPrice = (e) => {
          return props.setConsultationPrice(e.target.value);
      } 

      const brainstormPrice = props.brainstormPrice;
      const setBrainstormPrice = (e) => {
          return props.setBrainstormPrice(e.target.value);
      } 

      const mockPrice = props.mockPrice;
      const setMockPrice = (e) => {
          return props.setMockPrice(e.target.value);
      } 

      const personalStatementEditingPrice = props.personalStatementEditingPrice;
      const setPersonalStatementEditingPrice = (e) => {
          return props.setPersonalStatementEditingPrice(e.target.value);
      } 

      const secondaryStatementEditingPrice = props.secondaryStatementEditingPrice;
      const setSecondaryStatementEditingPrice = (e) => {
          return props.setSecondaryStatementEditingPrice(e.target.value);
      } 

        //handle consultation disable button
      const isConsultationInputEmpty = typeof window !== "undefined" && window.document.getElementById("consultation") ?  window.document.getElementById("consultation").value === "" : true;
      const consultationDisabledButton = consultationPrice === ""  ? true : false;


     //handle brainstorm disable button
      const brainstormGo =window.document.getElementById("brainstorm.go") ? window.document.getElementById("brainstorm.go").checked : null;
      const brainstormFormulate = window.document.getElementById("brainstorm.formulate") ? window.document.getElementById("brainstorm.formulate").checked : null;
      const brainstormDiscuss1 = window.document.getElementById("brainstorm.discuss1") ? window.document.getElementById("brainstorm.discuss1").checked : null;
      const brainstormDiscuss = window.document.getElementById("brainstorm.discuss") ? window.document.getElementById("brainstorm.discuss").checked : null;
      const brainstormShare = window.document.getElementById("brainstorm.share") ? window.document.getElementById("brainstorm.share").checked : null;
      const brainstormOther = window.document.getElementById("brainstorm.other") ? window.document.getElementById("brainstorm.other").checked : null;


      const allBrainstormKeysValues = brainstormFormulate || brainstormGo || brainstormDiscuss1 || brainstormDiscuss || brainstormShare || brainstormOther;
      const brainstormDisabledButton = brainstormPrice === "" || !allBrainstormKeysValues ? true : false;


      //handle secondary statement disable button

      const secondaryR1 =window.document.getElementById("secondaryStatementEditing.1r") ? window.document.getElementById("secondaryStatementEditing.1r").checked : null;
      const secondaryR2 = window.document.getElementById("secondaryStatementEditing.2r") ? window.document.getElementById("secondaryStatementEditing.2r").checked : null;


      const allSecondaryKeysValues = secondaryR1 || secondaryR2;

      const secondaryDisableButton = secondaryStatementEditingPrice === "" || !allSecondaryKeysValues ? true : false;


      //handle primary statement disable button

      const personalR1 =window.document.getElementById("personalStatementEditing.1r") ? window.document.getElementById("personalStatementEditing.1r").checked : null;
      const personalR2 = window.document.getElementById("personalStatementEditing.2r") ? window.document.getElementById("personalStatementEditing.2r").checked : null;


      const allPersonalKeysValues = personalR1 || personalR2;

      const personalDisableButton = personalStatementEditingPrice === "" || !allPersonalKeysValues ? true : false;

      //handle mock disable button

      const isMockInputEmpty = typeof window !== "undefined" && window.document.getElementById("mock") ?  window.document.getElementById("mock").value === "" : true;
      const mockDisableButton = mockPrice === "" || isMockInputEmpty  ? true : false;


      //test if any service in incomplete

      //brainstorm
      // const isAnyBrainstormCheckboxChecked = brainstormOption1 || brainstormOption2 || brainstormOption3 || brainstormOption4 || brainstormOption5 || brainstormOption6;
      // const isBrainstormHalfFilledUp = (isAnyBrainstormCheckboxChecked && !brainstormPrice) || (!isAnyBrainstormCheckboxChecked && brainstormPrice);
      const brainstormPricing = brainstormPrice === "" || brainstormPrice === 'NaN' ? false : true;
      const isAnyBrainstormCheckboxChecked = brainstormOption1 || brainstormOption2 || brainstormOption3 || brainstormOption4 || brainstormOption5 || brainstormOption6;
      const isBrainstormHalfFilledUp = (isAnyBrainstormCheckboxChecked && !brainstormPricing) || (!isAnyBrainstormCheckboxChecked && brainstormPricing);
  
      
      //personal
      // const isAnyPersonalStatementCheckboxChecked = personalOption;
      // const isPersonalHalfFilledUp = (isAnyPersonalStatementCheckboxChecked && !personalStatementEditingPrice )|| (!isAnyPersonalStatementCheckboxChecked && personalStatementEditingPrice);
      const personalPricing = personalStatementEditingPrice === "" || personalStatementEditingPrice === 'NaN' ? false : true;
      const isAnyPersonalStatementCheckboxChecked = personalOption;
      const isPersonalHalfFilledUp = (isAnyPersonalStatementCheckboxChecked && !personalPricing )|| (!isAnyPersonalStatementCheckboxChecked && personalPricing);
  
      
      
      //secondary
      // const isAnySecondaryStatementCheckboxChecked = secondaryOption;
      // const isSecondaryHalfFilledUp = (isAnySecondaryStatementCheckboxChecked && !secondaryStatementEditingPrice )|| (!isAnySecondaryStatementCheckboxChecked && secondaryStatementEditingPrice);
      const secondaryPricing = secondaryStatementEditingPrice === "" || secondaryStatementEditingPrice === 'NaN' ? false : true;
      const isAnySecondaryStatementCheckboxChecked = secondaryOption;
      const isSecondaryHalfFilledUp = (isAnySecondaryStatementCheckboxChecked && !secondaryPricing )|| (!isAnySecondaryStatementCheckboxChecked && secondaryPricing);
  
  
      
      
      //mock
      // const isAnyMockCheckboxSelected = mockOption;
      // const isMockHalfFilledUp = (mockPrice && !isAnyMockCheckboxSelected) || (!mockPrice && isAnyMockCheckboxSelected);
      const mockPricing = mockPrice === "" || mockPrice === 'NaN' ? false : true;
      const isAnyMockCheckboxSelected = mockOption;
      const isMockHalfFilledUp = (mockPricing && !isAnyMockCheckboxSelected) || (!mockPricing && isAnyMockCheckboxSelected);
  
  

      const isAnyServiceIncomplete = isBrainstormHalfFilledUp || isPersonalHalfFilledUp || isSecondaryHalfFilledUp || isMockHalfFilledUp;
   
      const publicData = props.listingData ? props.listingData.attributes.publicData : "";
      const isSignupFinished = publicData ? (publicData.consultationId || publicData.brainstormId || publicData.personalStatementEditingId || publicData.secondaryStatementEditingId || publicData.mockId) : true;
     
      return (
        <Form className={classes} onSubmit={handleSubmit} id="serviceForm">
          {errorMessageCreateListingDraft}
          {errorMessageUpdateListing}
          {errorMessageShowListing}
          {/* <FieldTextInput
            id="title"
            name="title"
            className={css.title}
            type="text"
            label={titleMessage}
            placeholder={titlePlaceholderMessage}
            maxLength={TITLE_MAX_LENGTH}
            validate={composeValidators(required(titleRequiredMessage), maxLength60Message)}
            autoFocus
          />

          <FieldTextInput
            id="description"
            name="description"
            className={css.description}
            type="textarea"
            label={descriptionMessage}
            placeholder={descriptionPlaceholderMessage}
            validate={composeValidators(required(descriptionRequiredMessage))}
          /> */}

          <FieldCheckboxGroup 
          className={css.editing} 
          id={"service"} 
          name={"service"} 
          options={serviceOptions} 
          service={"service"} 
          listingData={props.listingData.attributes.publicData} 
          listing={props.listingData} 
          handleServiceChange={handleServiceChange}
          serviceOption={serviceOption}
          showWarning={showWarning}
          setShowWarning={setShowWarning}
          checkedUnsavedService={checkedUnsavedService}
          setCheckedUnsavedService={setCheckedUnsavedService}
          submitDisabled={submitDisabled}
          isConsultationFilledUp={consultationPrice}
          setBrainstormCheckboxesFilled={setBrainstormCheckboxesFilled}
          isBrainstormPriceSelected={brainstormPrice}
          brainstormOption1={brainstormOption1}
          setBrainstormOption1={setBrainstormOption1}
          brainstormOption2={brainstormOption2}
          setBrainstormOption2={setBrainstormOption2}
          brainstormOption3={brainstormOption3}
          setBrainstormOption3={setBrainstormOption3}
          brainstormOption4={brainstormOption4}
          setBrainstormOption4={setBrainstormOption4}
          brainstormOption5={brainstormOption5}
          setBrainstormOption5={setBrainstormOption5}
          brainstormOption6={brainstormOption6}
          setBrainstormOption6={setBrainstormOption6}
          personalOption={personalOption}
          setPersonalOption={setPersonalOption}
          personalStatementEditingPrice={personalStatementEditingPrice}
          secondaryOption={secondaryOption}
          setSecondaryOption={setSecondaryOption}
          secondaryStatementEditingPrice={secondaryStatementEditingPrice}
          mockOption={mockOption}
          mockPrice={mockPrice}
          />

          {showWarning ? 
          <p className={css.warningText}>Please complete the service information before moving on to another one</p>  : null
        }
          {/* <CustomServiceSelectFieldMaybe
            id="service"
            name="service"
            serviceOptions={serviceOptions}
            intl={intl}
          /> */}

          {serviceOption === "consultation" ? (
            <div>
            {/* <FieldTextInput
            id="consultation"
            name="consultation"
            className={css.consult}
            type="textarea"
            label={rulesLabelMessage}
            placeholder={rulesPlaceholderMessage}
          /> */}
           <p><strong>CONSULTATION:</strong> 1 hour Zoom session for students to get all their questions answered by a current student! Students typically ask about the admissions process, extracurriculars, courses to take, research opportunities, how to study for standardized tests, etc! This session is catered to the student's needs.</p>
            <br/>
          <span>{pricePerUnitMessage}</span>
          <input
            id="consultationPrice"
            name="consultationPrice"
            className={css.priceInput}
            // autoFocus
            label={pricePerUnitMessage}
            placeholder={pricePlaceholderMessage}
            currencyConfig={config.currencyConfig}
            validate={priceValidators}
            type="number"
            step="0.01"
            onChange={setConsultationPrice}
            value={consultationPrice} 
          />
<span className={css.extraInformation}>
              <span> *The current range Helpers are offering for this service is from $30 to $100</span>
            <span>{` *You will receive the exact amount you requested. That being said, you will notice a difference in price on your profile from the one you listed. This fee goes towards running the platform and ensuring you have a great time on it!`}</span>
          </span>          </div>
          ) : null
        } 
          

        {serviceOption === "personalStatementBrainstorm" ? (
          <div>
             <p><strong>BRAINSTORM SESSION:</strong> 1 hour Zoom session to help students get started on their personal statement. Helpers brainstorm ideas, formulate an outline (using the student's past experiences, upbringing, etc.) & discuss common pitfalls to avoid when writing a personal statement. Some helpers choose to share excerpts of their own personal statement!</p>
             <br/>
          <p className={css.serviceInfoTitle}>Select all that apply & share anything else that you will do to make your session unique!! We've found that helpers are selected when they offer more of the below options! </p>
          <FieldCheckboxGroup
           className={css.brainstorm}
            id={"brainstorm"}
             name={"brainstorm"}
              options={brainstormOptions}
              brainstormOption1={brainstormOption1}
              setBrainstormOption1={setBrainstormOption1}
              brainstormOption2={brainstormOption2}
              setBrainstormOption2={setBrainstormOption2}
              brainstormOption3={brainstormOption3}
              setBrainstormOption3={setBrainstormOption3}
              brainstormOption4={brainstormOption4}
              setBrainstormOption4={setBrainstormOption4}
              brainstormOption5={brainstormOption5}
              setBrainstormOption5={setBrainstormOption5}
              brainstormOption6={brainstormOption6}
              setBrainstormOption6={setBrainstormOption6}
              
              /> 
          <span>{pricePerUnitMessage}</span>
          <input
            id="brainstormPrice"
            name="brainstormPrice"
            className={css.priceInput}
            // autoFocus
            label={pricePerUnitMessage}
            placeholder={pricePlaceholderMessage}
            currencyConfig={config.currencyConfig}
            validate={priceValidators}
            type="number"
            step="0.01"
            onChange={setBrainstormPrice}
            value={brainstormPrice} 
          />
<span className={css.extraInformation}>
              <span>*The current range Helpers are offering for this service is from $20 to $225</span>
              <span>{` *You will receive the exact amount you requested. That being said, you will notice a difference in price on your profile from the one you listed. This fee goes towards running the platform and ensuring you have a great time on it!`}</span>
          </span>          </div>
        ) : null}



          {serviceOption === "mockInterview" ? (
            <div>
       <p><strong>MOCK INTERVIEW:</strong>1 hour Zoom session to simulate interview day! Be sure to provide feedback at the end of the interview. We recommend a 30-40 minute interview and 20-30 minutes of feedback. </p>

             <br/>
            <CustomMockSelectFieldMaybe
            id="mock"
            name="mock"
            mockOptions={mockOptions}
            intl={intl}
            mockOption={mockOption}
            setMockOption={setMockOption}
            mockPrice={mockPrice}
          />

          <span>{pricePerUnitMessage}</span>
          <input
            id="mockPrice"
            name="mockPrice"
            className={css.priceInput}
            // autoFocus
            label={"How much would you charge for a 45 minute mock interview? Note: 30 minute mock interview, 15 minutes of feedback"}
            placeholder={pricePlaceholderMessage}
            currencyConfig={config.currencyConfig}
            validate={priceValidators}
            type="number"
            step="0.01"
            onChange={setMockPrice}
            value={mockPrice} 
          />
<span className={css.extraInformation}>
              <span>*The current range Helpers are offering for this service is from $20 to $175</span>
              <span>{` *You will receive the exact amount you requested. That being said, you will notice a difference in price on your profile from the one you listed. This fee goes towards running the platform and ensuring you have a great time on it!`}</span>
          </span>          </div>
          ) : null}
          

            {serviceOption ==="secondaryStatementEditing" ? (
              <div>
          <p><strong>SECONDARY STATEMENT EDITING:</strong> includes proofreading (grammar, structure, syntax) and providing 250-word feedback with tips.</p>
             <br/>
              <h2 className={css.serviceInfoTitle}>{panelTitle}</h2>
              <FieldCheckboxGroup 
              className={css.editing}
               id={"secondaryStatementEditing"}
                name={"secondaryStatementEditing"} 
                options={secondaryStatementEditingOptions} 
                editingService={true}
                secondaryOption={secondaryOption}
                setSecondaryOption={setSecondaryOption}
                secondaryStatementEditingPrice={secondaryStatementEditingPrice}
                />
             
              <span>{pricePerUnitMessage}</span>
              <input
                id="secondaryStatementEditingPrice"
                name="secondaryStatementEditingPrice"
                className={css.priceInput}
                // autoFocus
                label={pricePerUnitMessage}
                placeholder={pricePlaceholderMessage}
                currencyConfig={config.currencyConfig}
                validate={priceValidators}
                type="number"
                step="0.01"
                onChange={setSecondaryStatementEditingPrice}
                value={secondaryStatementEditingPrice} 
              /> 
              <span className={css.extraInformation}>
              <span>*The current range Helpers are offering for this service is from $25 to $125</span>
              <span>{` *You will receive the exact amount you requested. That being said, you will notice a difference in price on your profile from the one you listed. This fee goes towards running the platform and ensuring you have a great time on it!`}</span>
          </span>
              </div>
            ) : null}


              {/* {serviceOption === "letterOfIntent" ? (
              <div>
              <h2 className={css.title}>{panelTitle}</h2>
              <FieldCheckboxGroup className={css.editing} id={"letterOfIntent"} name={"letterOfIntent"} options={letterOfIntentOptions} />
              <FieldTextInput
                id="letterOfIntentPrice"
                name="letterOfIntentPrice"
                className={css.priceInput}
                autoFocus
                label={pricePerUnitMessage}
                placeholder={pricePlaceholderMessage}
                currencyConfig={config.currencyConfig}
                validate={priceValidators}
                type="number"
              /> 
              </div>
            ) : null} */}


            {serviceOption ==="personalStatementEditing" ? (
              <div>
                    <p><strong>PERSONAL STATEMENT EDITING:</strong> includes proofreading (grammar, structure, syntax) and providing 250-word feedback with tips.</p>
             <br/>
              <h2 className={css.serviceInfoTitle}>{panelTitle}</h2>
              <FieldCheckboxGroup 
              className={css.editing} 
              id={"personalStatementEditing"} 
              name={"personalStatementEditing"} 
              options={personalStatementEditingOptions} 
              editingService={true}
              personalOption={personalOption}
              setPersonalOption={setPersonalOption}
              personalStatementEditingPrice={personalStatementEditingPrice}
              />
              <span>{pricePerUnitMessage}</span>
              <input
                id="personalStatementEditingPrice"
                name="personalStatementEditingPrice"
                className={css.priceInput}
                // autoFocus
                label={pricePerUnitMessage}
                placeholder={pricePlaceholderMessage}
                currencyConfig={config.currencyConfig}
                validate={priceValidators}
                type="number"
                step="0.01"
                onChange={setPersonalStatementEditingPrice}
                value={personalStatementEditingPrice} 
                
              /> 
              <span className={css.extraInformation}>
              <span>*The current range Helpers are offering for this service is from $30 to $200</span>
              <span>{` *You will receive the exact amount you requested. That being said, you will notice a difference in price on your profile from the one you listed. This fee goes towards running the platform and ensuring you have a great time on it!`}</span>
                
              
          </span>
              </div>
            ) : null}
          <div className={css.submitButton}>

            {isSignupFinished ? null : isAnyServiceIncomplete ? <p className={css.serviceIncompleteWarningText}>Some services that you have started filling out are incomplete. Please complete them before moving to the next step</p> : null} 

          <Button
            
            type="submit"
            inProgress={submitInProgress}
            disabled={ serviceOption === "consultation" ? consultationDisabledButton === true || isAnyServiceIncomplete === true ? true : false :
            serviceOption === "personalStatementBrainstorm" ? brainstormDisabledButton === true || isAnyServiceIncomplete === true ? true : false: 
            serviceOption ==="secondaryStatementEditing" ? secondaryDisableButton === true || isAnyServiceIncomplete === true ? true : false: 
            serviceOption ==="personalStatementEditing" ? personalDisableButton === true || isAnyServiceIncomplete === true ? true : false: 
            serviceOption === "mockInterview" ? mockDisableButton === true || isAnyServiceIncomplete === true ? true : false : false
          }  
            ready={submitReady}
          >
            {saveActionMsg}
          </Button>
          </div>
        </Form>
      );
    }}
  />

);}

EditListingServiceInfoFormComponent.defaultProps = { className: null, fetchErrors: null };

EditListingServiceInfoFormComponent.propTypes = {
  className: string,
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  fetchErrors: shape({
    createListingDraftError: propTypes.error,
    showListingsError: propTypes.error,
    updateListingError: propTypes.error,
  }),
  serviceOptions: arrayOf(
    shape({
      key: string.isRequired,
      label: string.isRequired,
    })
  ),
};

export default compose(injectIntl)(EditListingServiceInfoFormComponent);

